<script>
    import { createEventDispatcher } from "svelte";
    import { PreferencesStore } from "$/stores/global/PreferencesStore";
    import { ExtensionStore } from "$/stores/ExtensionStore";
    import { sanitizeHTMLCardContent } from "$/utils/Utils";
    import CardContentWrapper from "$/components/card/CardContent/CardContentWrapper.svelte";

    const dispatch = createEventDispatcher();

    const currentPageUrl = window.location.origin + window.location.pathname;

    async function onCreate() {
        dispatch("create");
    }

    $: cardContent = sanitizeHTMLCardContent($ExtensionStore.card.content);
</script>

<div
    id="js-new-card"
    class="new-card"
    class:place-bottom={$PreferencesStore?.addCardsToTheBottom}
>
    <div class="new-card__header">
        {currentPageUrl.replace("http://", "").replace("https://", "")}
    </div>
    <CardContentWrapper>
        {@html cardContent}
    </CardContentWrapper>
    <div class="new-card__footer">
        <span class="new-card__tooltip">
            Press
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 16 16"
            >
                <path
                    fill-rule="evenodd"
                    d="M14.5 1.5a.5.5 0 0 1 .5.5v4.8a2.5 2.5 0 0 1-2.5 2.5H2.707l3.347 3.346a.5.5 0 0 1-.708.708l-4.2-4.2a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 8.3H12.5A1.5 1.5 0 0 0 14 6.8V2a.5.5 0 0 1 .5-.5z"
                    clip-rule="evenodd"
                />
            </svg>
        </span>
        <button
            class="new-card__btn"
            on:mousedown|preventDefault|stopPropagation={onCreate}
        >
            Create
        </button>
    </div>
</div>

<style>
    .new-card {
        @apply reset flex w-full flex-none scroll-m-4 flex-col rounded-xl bg-yellow-100 shadow-sm !important;
    }

    .new-card.place-bottom {
        @apply order-1 !important;
    }

    .new-card__header {
        @apply reset m-0 w-full max-w-[-webkit-fill-available] truncate rounded-t-xl border-b border-solid border-yellow-300 bg-yellow-100 px-4 py-1 text-xs no-underline outline-none !important;
    }

    .new-card__footer {
        @apply reset flex justify-end border-t border-yellow-200 px-2 pb-2 pt-1 !important;
    }

    .new-card__tooltip {
        @apply reset mx-2 flex items-center gap-1 text-xs text-yellow-600 !important;
    }

    .new-card__tooltip svg {
        @apply h-3 w-3 text-yellow-600 !important;
    }

    .new-card__btn {
        @apply reset cursor-pointer rounded-sm px-2 py-1 text-xs font-bold hover:bg-yellow-300 !important;
    }
</style>
